import Api from "./api";
import { project } from "../hooks/auth";

const buildUrl = (campaignId, action) =>
  `/login-update-notice/${campaignId}/${action}`;

const resolveAuthorizationHeader = () => {
  const headerFromDefaults =
    Api?.defaults?.headers?.authorization ||
    Api?.defaults?.headers?.common?.authorization ||
    Api?.defaults?.headers?.Authorization ||
    Api?.defaults?.headers?.common?.Authorization;

  if (headerFromDefaults) return String(headerFromDefaults);

  const token = localStorage.getItem(`${project}:token`);
  if (!token) return "";
  return `Bearer ${token}`;
};

const buildClickUrl = (campaignId) => {
  const baseURL = String(Api?.defaults?.baseURL || "").replace(/\/+$/, "");
  return `${baseURL}${buildUrl(campaignId, "click")}`;
};

/**
 * Dispara o evento de impressão da campanha de login-update-notice.
 * Usa o axios padrão (Api). Falha silenciosa: nunca deve gerar erro visível.
 */
const trackImpression = (campaignId, { eventId, interactionId } = {}) => {
  if (!campaignId || !eventId || !interactionId) return Promise.resolve();

  return Api.post(buildUrl(campaignId, "impression"), {
    eventId,
    interactionId,
  }).catch(() => {});
};

/**
 * Dispara o evento de clique da campanha de login-update-notice.
 * Usa fetch nativo com keepalive para sobreviver à navegação quando a
 * campanha abre na mesma aba. Não usa axios pois não pode depender do
 * interceptor para obter o token (precisa ser resolvido aqui mesmo).
 * Falha silenciosa: nunca deve gerar erro visível.
 */
const trackClick = (campaignId, { eventId, interactionId } = {}) => {
  if (!campaignId || !eventId || !interactionId) return Promise.resolve();

  const authorization = resolveAuthorizationHeader();
  const headers = { "Content-Type": "application/json" };
  if (authorization) headers.Authorization = authorization;

  try {
    return fetch(buildClickUrl(campaignId), {
      method: "POST",
      keepalive: true,
      headers,
      body: JSON.stringify({ eventId, interactionId }),
    }).catch(() => {});
  } catch {
    return Promise.resolve();
  }
};

const LoginUpdateNoticeAnalyticsService = {
  trackImpression,
  trackClick,
};

export default LoginUpdateNoticeAnalyticsService;
